import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import SiteSessionAction from './SiteSessionAction';

/**
 * Site details page header: back link, breadcrumb (desktop), title, and test actions.
 * Display-only; all data and handlers come from the parent via props.
 */
export default function SiteDetailsHeader({
  isMobile,
  siteId,
  siteName,
  inProgressSessionsThisSite,
  onStartNewTest,
}) {
  if (isMobile) {
    return (
      <>
        <h1 className="page-title site-details-title-mobile">{siteName}</h1>
        <div className="page-header-actions site-details-actions-mobile" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', alignItems: 'stretch' }}>
          <Button
            type="button"
            className="site-test-action-btn"
            onClick={onStartNewTest}
          >
            Start New Test
          </Button>
          {inProgressSessionsThisSite.map((s) => (
            <SiteSessionAction key={s.id} session={s} siteId={siteId} />
          ))}
        </div>
      </>
    );
  }

  return (
    <>
      <p style={{ marginBottom: '0.75rem' }}>
        <Link to="/sites" className="link">&lt; Back to Sites</Link>
      </p>
      <div className="breadcrumb">
        <Link to="/sites" className="breadcrumb-link">Sites</Link>
        <span className="breadcrumb-sep">›</span>
        <span className="breadcrumb-current">{siteName}</span>
      </div>
      <div className="page-header" style={{ flexWrap: 'wrap', gap: '1rem' }}>
        <h1 className="page-title" style={{ marginBottom: 0 }}>{siteName}</h1>
        <div className="page-header-actions" style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', alignItems: 'center' }}>
          <Button
            type="button"
            className="site-test-action-btn"
            onClick={onStartNewTest}
          >
            Start New Test
          </Button>
          {inProgressSessionsThisSite.map((s) => (
            <SiteSessionAction key={s.id} session={s} siteId={siteId} />
          ))}
        </div>
      </div>
    </>
  );
}
